module.exports = __webpack_public_path__ + "img/onlin.67782747.png";